import './css/main.css';
import Image1 from './images/achievements.png'
import Image2 from './images/avatar.png'
import Image3 from './images/coding.png'
import Image5 from './images/education.png'
import Image6 from './images/email.png'
import Image8 from './images/lingkaran.png'
import Image9 from './images/linkedin.png'
import Image10 from './images/sertif.png'
import Image11 from './images/telpon.png'
import Porto from './components/porto'
import Card from './components/card'
import React from 'react';
import axios from 'axios';
class App extends React.Component {
    constructor(props) {
        super(props)
      
        this.state = {
           name: '',
           email: '',
           message: ''
        }
      }

      changeHandler = (e) => {
        this.setState({[e.target.name] : e.target.value})
      }
    
      submitHandler = e => {
        e.preventDefault();
        axios.post('https://sheet.best/api/sheets/de9a8c73-530a-4858-8229-30a01f3a7286', this.state)
        .then(response => {
        console.log(response);
        window.alert("Pesan berhasil dikirim :D")
    })
      }

    render(){
        return (
            <>
            <ul className="nav">
                <li className="nav-icon desktop"><img src={Image2} alt="iconAvatar" /></li>
                <li><a href="#section-introduction">About Me</a></li>
                <li><a href="#section-portofolio">My Portofolio</a></li>
                <li><a href="#section-contactme">Contact Me</a></li>
            </ul>
            <div id="perkenalan">
                <h1 id="Welcome-Text">Hello! <br></br>Welcome to Michael Jonathan's Page</h1>
                <br></br>
            </div>
            <div style={{backgroundColor: 'black', height: '2cm', color: 'black'}}></div>
            <div id="intro">
            <div id="section-introduction">
                <div className="introduce">
                    <img src={Image8} alt="Gambar Pribadi" className="gambar-pribadi" />
                    <p className="perkenalandiri">Let me introduce myself. My name is Michael Jonathan Halim, an ITB student from STEI faculty, who focuses on Informatics Engineering, currently studying Software Engineering (Full Stack Developer), Data Science, and Mobile App Development.</p>
                </div>
                <div className="education">
                    <img src={Image5} alt="edukasi" className="gambar-edukasi" />
                    <p className="edukasidiri">I have graduated from senior high school at SMAK Penabur Gading Serpong in 2021. I have been an ITB undergraduate student in the faculty of the School of Informatics and Electrical Engineering since 2021.</p>
                </div>
                <div className="working">
                    <img src={Image3} alt="codingimage" className="gambar-working" />
                    <p className="codingdiri">I have been learning how to code since I was 15 years old. I have been focusing on Competitive Programming and currently focusing on Software Engineering (Full Stack Developer) and Machine Learning. One of the projects made by myself is this website. Programming Languages which I can use are C++, Python, HTML, CSS (Bootstrap), JavaScript, PHP (Laravel).</p>
                </div>
                <div className="achievements">
                    <img src={Image1} alt="" className="gambar-edukasi" />
                    <p className="codingdiri">I have been a participant of Olimpiade Sains Provinsi Banten Komputer 2019, Semi-finalist for JOINTS UGM 2019, Top 25 Percent Cayley Contest 2019 University of Waterloo (International), First Place (1st) Tryout UTBK Ruangguru (National), First Place (1st) Tryout Akbar UTBK Telkomsel (Top 1 in Indonesia), First Place (1st) Indonesia Cardistry Contest 2019 (As a Cinematographer and Video Editor).</p>
                </div>
                <div className="certificates">
                    <img src={Image10} alt="" className="gambar-certificates" />
                    <p className="codingdiri">I have attended a seminar about IT Career Preparation by Alterra Academy. I also have participated in the Brilliant Class Gading Serpong Computer Olympiad, Video Editing Workshop, Dicoding Python Class, Dicoding Data Visualization Class, Dicoding Machine Learning Class, and Coding Studio Full Stack Developer Class.</p>
                </div>
                <br></br>
                <br></br>
            </div>
            </div>
            <div id="section-portofolio" style={{backgroundColor: 'black', height: '2cm', color: 'black'}}></div>
            <div className='section-portofolio'>
                <div className='main-portofolio'>
                    <h1>My Portofolio</h1>
                    <div className='porto'>
                    {Porto.data.map((item) => <Card key={item.title} title={item.title} image={item.image} link={item.link} desc={item.description}/>)}
                    </div>
                </div> 
                <br></br>
            </div>
            <div style={{backgroundColor: 'black', height: '2cm', color: 'black'}}></div>
            <div id="section-contactme">
                <br></br> <p></p> <br></br>
                <h1 id="contact-me">Contact Me</h1>
                <form id="myForm" onSubmit={this.submitHandler}>
                    <div className="classnama">
                        <label htmlFor="name" id="labelnama">Name</label>
                        <input type="text" id="inputnama" name="Nama" value={this.name} onChange={this.changeHandler}/>
                    </div>
                    <div className="classemail">
                        <label htmlFor="email" id="labelemail">Email</label>
                        <input type="email" id="inputemail" name="Email" value={this.email} onChange={this.changeHandler}/>
                    </div>
                    <div className="classpesan">
                        <label htmlFor="pesan" id="labelpesan">Message</label>
                        <textarea name="Pesan" id="textpesan" cols="30" rows="10" itemID="" value={this.message} onChange={this.changeHandler}></textarea>
                    </div>
                    <button id="buttonsend" type='submit' style={{cursor:"pointer"}}>Submit</button>
                </form>
                <div className="contact-info">
                    <div>
                        <a href="tel:0812-9933-0950" className="contacthp">
                            <img src={Image11} alt="" className="gambar-contact" />
                            <span className="contact-desktop">081299330950</span>
                        </a>
                    </div>
                    <div>
                        <a href="mailto:itsmichaeljonathan@gmail.com" className="contactemail">
                            <img src={Image6} alt="" className="gambar-contact" />
                            <span className="contact-desktop">itsmichaeljonathan@gmail.com</span>
                        </a>
                    </div>
                    <div>
                        <a href="https://www.linkedin.com/in/michael-jonathan-halim-a33348142/" target="_blank" rel="noreferrer" className="contactlinkedin">
                            <img src={Image9} alt="" className="gambar-contact" />
                            <span className="contact-desktop">Michael Jonathan Halim</span>
                        </a>
                    </div>
                </div>
                <br></br> <p></p> <br></br>
            </div>
            <footer>Created by Michael Jonathan</footer>
            </>
        );
        }
}

export default App;
